import { render } from "./addDictData.vue?vue&type=template&id=e5af5be0"
import script from "./addDictData.vue?vue&type=script&lang=js"
export * from "./addDictData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__